export const exactLengthRegex = (length) => `^[a-zA-Z0-9]{${length}}$`;
export const onlyNumbersRegex = "^[0-9]*$";
export const onlyDecimalsRegex = "^[0-9]*(\\.[0-9]+)?$";
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const urlRegex = /^(http(s)?:\/\/)?[^\s/?.#-]+(\.[^\s/?.#-]+)+(\/[^\s]*)*$/;
export const isGreaterThanRegex = (limit) => `^${limit < 0 ? '-' : ''}(?!0+$)\\d+\\.?\\d*$|^${limit}$`
export const rangeLengthRegex = (minLength, maxLength) => `^[a-zA-Z0-9]{${minLength},${maxLength}}$`;